import styled, {ThemeProps, keyframes, css} from 'styled-components';
import {Theme} from './../../../../../theme/types';
import {Column, Row} from './../../../common/Layouts/Layouts';

const Container = styled.div(
  props => css`
    background-image: linear-gradient(to left, #f4f4f4, #ececec);
  `
);

export const HotelDetailsLoaderComponentWrapDiv = styled(Column)(
  (props: ThemeProps<Theme>) => `
    width:59%;
    justify-content: space-between;
  `
);

export const HotelDetailsFirstLoaderWrapDiv = styled(Row)(
  (props: ThemeProps<Theme>) => `
    justify-content: space-between;
  `
);

export const RatingLoaderWrapSpan = styled(Row)(
  (props: ThemeProps<Theme>) => css`
    width:9.5rem;
    border-radius:${props.theme.misc.borderRadius.small};
    height:2rem;
    background-image: linear-gradient(to left, #f4f4f4, #ececec);
  `
);

export const HotelNameLoaderWrapDiv = styled(Container)(
  props => `
    display:flex;
    flex-wrap: wrap;
    flex-direction: row;
    width:15.3rem;
    border-radius:${props.theme.misc.borderRadius.small};
    height:2rem;
    margin-top:${props.theme.spacing.base};
  `
);

export const AddressLoaderWrapDiv = styled(Container)(
  props => `
    display:flex;
    flex-wrap: wrap;
    flex-direction: row;
    width:9.1rem;
    border-radius:${props.theme.misc.borderRadius.small};
    height:1.2rem;
    margin-top:${props.theme.spacing.base};
  `
);

export const AmminitiesLoaderWrapDiv = styled(Container)(
  props => `
    display:flex;
    flex-wrap: wrap;
    flex-direction: row;
    width:28rem;
    border-radius:${props.theme.misc.borderRadius.small};
    height:1.7rem;
    margin-top:${props.theme.spacing.base};
  `
);
